import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import AutocompleteField from "../../components/field/AutocompleteField";

import { useTranslation } from "react-i18next";
import { useForm } from "../../hooks/useForm";
import { useInvestmentSelectList } from "../../services/productsService";

export function SelectInvestmentsForDocumentDialog(props) {
    const { t } = useTranslation();
    
    const { data: investmentList } = useInvestmentSelectList(props.withoutProspectus ? { without_prospectus: true } : {});

    const { formValue, onChangeAutocompleteFieldWithObjectOptions } = useForm({});

    const handleConfirm = () => {
        props.onConfirm(formValue.investment);
    };

    const handleClose = () => {
        props.onClose();
    };

    const hasSelectedInvestment = formValue.investment;

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("documents.DocumentsPage.selectInvestmentForDocument")}</DialogTitle>
            <DialogContent>
                <Grid item xs={12}>
                    <AutocompleteField
                        name="investment"
                        multiple={true}
                        addNewValue={false}
                        onChange={onChangeAutocompleteFieldWithObjectOptions}
                        options={investmentList || []}
                        label={t("products.investment")}
                        isObjectOption
                        optionLabelKey="investment_name_sales"
                        value={formValue?.investment}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {t("cancel")}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!hasSelectedInvestment}
                >
                    {t("confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
